import {SpinnerDotted} from "spinners-react";
const Button = (props) => {
    const loading = props.loading;
    return (
        <button
            disabled={props.disabled}
            className="bg-blue-500 rounded p-3 text-white w-[80px]"
            {...props}
        >
            <span className="flex items-center w-full justify-center">
                {!loading && <span>{props.text}</span>}
                {loading && (
                    <span>
                        <SpinnerDotted
                            size={20}
                            thickness={150}
                            speed={100}
                            color="rgba(255, 255, 255, 1)"
                        />
                    </span>
                )}
            </span>
        </button>
    )
}

export default Button;